<template>
    <div>
        <page-header title="Confirm Shipment Receipt" breadcrumb="Bookung & Shipment > Dispatch Timeline > Manifest"
            :back="-1" />
        <div class=" text-gray-400 text-sm py-3 pt-0">
            Please confirm that the customer's shipment has been received at the terminal. Verify the shipment details
            before confirming.
        </div>
        <section class=" bg-white py-4 px-3 rounded-2xl">
            <div class="top_list">
                <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img class="" src="../../../../assets/images/icons/number-hash-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Consolidation ID: #{{ manifest?.dispatchReference}}
                    </p>
                </div>

                <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img src="../../../../assets/images/icons/list-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Shipment Count: {{ manifest?.shipments?.length }}
                    </p>
                </div>

                <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img src="../../../../assets/images/icons/list-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Item Count: {{ manifest?.shipments?.length }}
                    </p>
                </div>

                <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img src="../../../../assets/images/icons/weight-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Total weight: 34
                    </p>
                </div>

                  <div class="top_list_item">
                    <p class="top_list_item_img">
                        <img src="../../../../assets/images/icons/weight-icon.png" />
                    </p>
                    <p class="top_list_item_title">
                        Arrival Date: {{ formatDate(manifest?.createdAt) }}
                    </p>
                </div>
            </div>
            <div class=" bg-primary-green text-white px-3 py-4 my-3 flex gap-4 items-center rounded-xl">
                <div>
                    <span class="standard_wrapper">
                        <img src="@/assets/images/ondemand/fluent-arrow.svg" class="img_standard" />
                    </span>
                </div>
                <div>
                    <b>{{ "Standard Shipping" }}</b>
                    <p>{{ "This order has been shipped to the customer" }}</p>
                </div>
            </div>
        </section>

        <section class="bg-white py-4 rounded-2xl mt-4">
            <consolidationInfo :manifest="manifest" />
        </section>

        <div class=" flex items-center justify-between px-3 mt-4">
            <span class=" font-[500]">Shipment Details</span>
            <span class=" cursor-pointer flex items-center gap-2" @click="collapse = !collapse">Collapse <img
                    src="@/assets/images/arrow-up.svg" :class="[collapse && 'rotate-180']"
                    class=" transition-all duration-200" /></span>
        </div>
        <section v-if="!collapse" class=" rounded-2xl bg-white">
            <div class="px-0 rounded-md mt-4  overflow-hidden py-3">
                <table class="custom-table responsive-table border-collapse custom_classs">
                    <thead>
                        <tr class="shadow-md rounded-lg">
                            <th>SHIPPING ID</th>
                            <th>ITEM COUNT</th>
                            <th>SENDER</th>
                            <th>RECEIVER</th>
                            <th>ITEM DESCRIPTION</th>
                            <th>QUANTITY</th>
                            <th>WEIGHT</th>
                            <th>SHIPPING INSTRUCTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(shipment, index) in (manifest.shipments || [])" :key="index + 'items'"
                            class="shadow-md rounded-lg">
                            <td>{{ shipment?.shippingReference }}</td>
                            <td>{{  shipment?.itemCount}}</td>
                            <td>{{ shipment?.sender?.name }}</td>
                            <td>{{ shipment?.receiver?.name }}</td>
                            <td>{{ shipment?.description }}</td>
                            <td>{{ shipment?.itemCount }}</td>
                            <td>{{ shipment?.totalWeight }}</td>
                            <td>{{ shipment?.shippingInstruction }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <section class="mt-5">

            <label class="label">Verification Checklist</label>
            <div class="w-full pb-1 mt-3">
                <div v-for="ver in verify" :key="ver" class="flex gap-3 items-center py-2 my-2">
                    <input class="checkbox" type="checkbox" @change="changedValue($event, ver)"
                        :checked="value_(route)" />
                    <span>{{ ver }}</span>
                </div>
            </div>
            <div class="w-full mt-3">
                <label class="label">Comment <span class=" text-gray-400">(Optional)</span></label>
                <textarea @input="checkTextlength($event)" type="number" v-model="moreDetails"
                    placeholder="Add any observation about the shipment condition"
                    class="input-mini_textarea"></textarea>
                <div class="text-right w-full md:w-6/12">
                    {{ (moreDetails || "").length }}/300
                </div>
            </div>
            <div class="mt-0 w-full md:w-6/12">
                <label>Upload Documents</label>
                <div :style="{
                    'background-color': '#FBFCFE',
                    border: '1px solid #DAE8F6',
                }" class="pt-2 px-3 rounded-lg overflow-hidden flex justify-between pb-2 w-full">
                    <div :style="{ color: '#B7BDCD', fontSize: '16px' }" class="mt-1 w-9/12">
                        <p v-if="!isUploadingDoc && !docUploaded">Upload File</p>
                        <div v-if="isUploadingDoc" class="d-flex justify-content-center py-2 -mt-2">
                            <saving-loader :icon-color="'#0253B3'" />
                        </div>
                    </div>

                    <button @click="payload.documentUrl.length < 1 && (triggerUpload = true)" :style="{
                        'background-color': '#CBE0F6',
                        height: '32px',
                        width: '91px',
                    }" class="rounded-lg w-3/12">
                        Upload
                    </button>
                </div>

                <div class="mt-3">
                    <div class="image_list" v-for="url in payload.documentUrl" :key="url">{{ url.substring(url.length -
                        20)
                    }}<button @click="removeImageUrl(url)">&#x2715;</button>
                    </div>
                </div>

                <document-upload hidden ref="documentUploader" @input="handleDocUpload($event)"
                    @closeTrigger="triggerUpload = false" @remove-image="removeImage" :docurl="docurl"
                    :triggerUpload="triggerUpload" :isUploadingImage="isUploadingDoc" />
            </div>
        </section>

        <div class="flex justify-end mt-5">
            <base-button text="Confirm Receipt" @click="confirmReciept" :loading="loading" :disabled="disabled" />
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import consolidationInfo from "./newdispatch/modules/consolidation-info.vue";
import SavingLoader from "@/components/UI/ButtonSavingLoader";
import moment from "moment"

export default {
    components: {
        PageHeader,
        consolidationInfo,
        SavingLoader
    },
    data() {
        return {
            collapse: false,
            isUploadingDoc: false,
            triggerUpload: false,
            fileName: null,
            docUploaded: false,
            isLoading: false,
            moreDetails: "",
            selectedVerify: [],
            loading: false,
            manifest: {},
            verify: [
                "Packages received match the shipment record",
                "Packages are not visibly damaged",
                "Shipment has been logged into terminal inventory"
            ],
            payload: {
                documentUrl: []
            }
        }
    },
    mounted() {
        this.getDispatchManifest();
    },
    computed: {
        disabled() {
            return this.selectedVerify.length < 3
        }
    },
    methods: {
        formatDate(date){
            return moment(date).format('D MMM YYYY')
        },
        async getDispatchManifest() {
            const response = await this.$_getDispatchManifest(this.$route.params.id, {dispatchType: 'long_haul'});
            this.manifest = response.data.data
        },
        async confirmReciept() {
            this.loading = true;
            const payload = {
                comment: this.moreDetails,
                evidenceUrl: this.payload.documentUrl[0]
            }
            try {
                await this.$_confirmDispatchShipment(this.$route.params.id, payload);
                this.generateToast('Confirm Reciept Successful', 'success');
                this.$router.go(-1);
            } catch (error) {
                // code here
            } finally{
                this.loading = false;
            }
        },
        changedValue(checked, route) {
            checked.target.checked && this.selectedVerify.push(route)
            if (!checked.target.checked) {
                this.selectedVerify = this.selectedVerify.filter((item) => item !== route)
            }
        },
        value_(verify) {
            return this.selectedVerify.includes(verify)
        },
        checkTextlength(event) {
            let value = event.target.value;
            if ((this.moreDetails || "").length > 300) {
                this.moreDetails = value.substring(0, 300);
                return;
            }
            this.moreDetails = value;
        },
        removeImageUrl(val) {
            this.payload.documentUrl = this.payload.documentUrl.filter(url => url != val)
        },
        async handleDocUpload(image) {
            this.isUploadingDoc = true;
            this.triggerUpload = false;
            this.fileName = image.name;
            this.docUploaded = false;

            try {
                let response = await this.updateDocument(image);
                this.docurl = response;
                this.payload.documentUrl.push(response);
                this.isUploadingDoc = false;
                this.docUploaded = true;
                this.generateToast("Document uploaded", "success");
            } catch (error) {
                this.handleError(error);
                this.isUploadingDoc = false;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.detailsItem {
    @apply flex flex-wrap mb-1
}

.top_list_item_title {
    @apply font-semibold flex-1 mt-1 text-base
}

.top_list_item_img {
    @apply mt-1 -mr-8 w-14
}

.top_list_item {
    @apply w-[20%] px-4 flex flex-wrap justify-evenly border-r-2 border-gray-200 items-center gap-2 mt-3
}

.top_list {
    @apply w-full flex flex-wrap items-center
}

.standard_wrapper {
    @apply w-[50px] h-[50px] rounded-full bg-white inline-flex justify-center items-center;
}

.img_standard {
    @apply w-[30px] h-[30px]
}

.image_list {
    @apply flex items-center justify-between w-full border border-gray-400/40 bg-primary-blue/5 px-2 py-2 mt-2
}

.input-mini_textarea {
    @apply w-full md:w-6/12 p-4 border-[1px] border-gray-700/20 rounded-lg bg-transparent resize-none h-36;
}

.label {
    @apply w-full block text-base
}

.checkbox {
    width: 1.4rem;
    height: 1.4rem;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    background-color: #e5e7eb;
    /* gray */
    border: none;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.25rem;
}

.checkbox:checked {
    background-color: #facc15;
    /* your yellow */
}

.checkbox:checked::after {
    content: "";
    margin-top: -2px;
    width: 0.35rem;
    height: 0.7rem;

    border: solid white;
    border-width: 0 2px 2px 0;

    transform: rotate(45deg);
    display: block;
}
</style>